export default function Button({
	children,
	...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) {
	return (
		<button
			{...props}
			className="bg-gray-50 text-black border border-gray-500 pl-12 pr-12 pt-1 pb-1 rounded-md cursor-pointer"
		>
			{children}
		</button>
	);
}
